<template>
  <b-card class="search-view-lessonsearch">
    <router-link
      :to="{
        name: 'lesson',
        params: {
          slug: slugfy(results.name),
          lesson: results.id,
          id: results.course
        }
      }"
    >
      <img
        :src="results.thumbnail"
        :alt="results.name"
        class="card-img-top img-fluid"
      />
      <div class="card-body">
        <h5 class="card-title mt-2 text-center">{{ results.name }}</h5>
      </div>
    </router-link>
  </b-card>
</template>

<script>
import { slugfy } from "@/functions/helpers.js";

export default {
  props: {
    results: {
      type: Object
    }
  },
  methods: {
    slugfy
  }
};
</script>
<style lang="scss" scoped>
.search-view-lessonsearch {
  background-color: rgba(0, 0, 0, 0.3);
  padding-bottom: 5%;
}
</style>
